<app-section
  [titleSection]="'Votre ' + expert.roleLabel"
  [isLargeTitle]="true"
  [isActivated]="expert.isEnabled"
  (enabled)="onEnabled($event)"
  (cancled)="onCancled()"
>
  <div read-mode class="px-3">
    <app-expert-immobilier-read-mode
      [expert]="expert"
      [exportPhoto]="exportPhoto"
    >
    </app-expert-immobilier-read-mode>
  </div>

  <div edit-mode>
    <app-expert-immobilier-edit-mode
      [expert]="expert"
      [reportId]="reportId"
      [exportPhoto]="exportPhoto"
      (expertChanged)="onExpertChanged($event)"
      [roles]="roles"
    >
    </app-expert-immobilier-edit-mode>
  </div>

  <div save-button>
    <p-button
      id="btn-valider-section"
      label="Valider"
      level="primary"
      title="Valider"
      [loading]="isLoading"
      [disabled]="isLoading"
      (click)="onSaveSection()"
    ></p-button>
  </div>
</app-section>
